module.exports = __webpack_public_path__ + "static/img/20b.8737796.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20b.png
// module id = 4wZ3
// module chunks = 1